import { useEffect } from "react";

const ZoneIntegrated = ({language , token}) => {
  const translaterRouter = {
    "podcast/list" : "/media/podcast",
    "medias/videos" : "/media/video",
    "playlist/list/simple" : "/media/playlist",
    "lives/list" : "/media/lives",
    "boitiers/zone_boitier":"/boitier/zone",
    "statsPerVideo":"/media/video"
  }
  const newZoneIframe = "https:" +
    window.process.env.URL_Boitier_Zone
    +  "?lang=" + language + "&token=" +
      token + ""
  
      useEffect(()=>{
          window.addEventListener("message",(event)=>{
            if(event.data.info === "statsPerVideo") {
              const parentUrl = window.parent.location.href;
              let newUrl;
              if(parentUrl.includes("/dashboard")){
                newUrl = parentUrl.replace('/dashboard', translaterRouter[event.data.data]);
              }else{
               newUrl =translaterRouter[event.data.info] + '/' + event.data.value.id;
              }
              window.parent.location.href = newUrl;  
             }
          },false)
      },[])
    return (
      <iframe
        id="iframe_Zone_display"
        src={newZoneIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default ZoneIntegrated